module.exports = __webpack_public_path__ + "img/Christopher.5657b580.jpeg";